module.exports = __webpack_public_path__ + "img/lALPDhmOw39u8LZszQFq_362_108.png_720x720q90g.72ad8a5f.jpg";